






import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class BtnSignInGoogle extends Vue {
    mounted() {
        let el = document.getElementById('buttonDiv') as HTMLFormElement;
        let options: google.accounts.id.GsiButtonConfiguration = {
            theme: 'outline',
            size: 'large',
            type: 'standard'
        };
        google.accounts.id.renderButton(el, options);
    }
}
